"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog as DialogPrimitive } from "@base-ui/react/dialog";
import { Button } from "@multi-tenant-cms/ui/components/button";
import { cn } from "@multi-tenant-cms/ui/lib/utils";
import { X } from "lucide-react";
import type * as React from "react";
function Dialog(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Root data-slot="dialog" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DialogTrigger(t0) {
  const $ = _c(9);
  let props;
  let render;
  if ($[0] !== t0) {
    ({
      render,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = render;
  } else {
    props = $[1];
    render = $[2];
  }
  let t1;
  if ($[3] !== render) {
    t1 = !render && {
      "data-slot": "dialog-trigger"
    };
    $[3] = render;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== render || $[7] !== t1) {
    t2 = <DialogPrimitive.Trigger {...t1} render={render} {...props} />;
    $[5] = props;
    $[6] = render;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function DialogClose(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Close data-slot="dialog-close" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DialogPortal(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Portal data-slot="dialog-portal" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DialogOverlay(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("fixed inset-0 z-50 bg-black/40 transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0 supports-backdrop-filter:backdrop-blur-sm", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <DialogPrimitive.Backdrop className={t1} data-slot="dialog-overlay" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DialogContent(t0) {
  const $ = _c(20);
  let children;
  let className;
  let overlayClassName;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      children,
      overlayClassName,
      showCloseButton: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = overlayClassName;
    $[4] = props;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    overlayClassName = $[3];
    props = $[4];
    t1 = $[5];
  }
  const showCloseButton = t1 === undefined ? true : t1;
  let t2;
  if ($[6] !== overlayClassName) {
    t2 = <DialogOverlay className={overlayClassName} />;
    $[6] = overlayClassName;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== className) {
    t3 = cn("fixed top-1/2 left-1/2 z-50 w-full max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-2xl border bg-popover bg-clip-padding p-6 text-popover-foreground shadow-xl transition duration-200 data-ending-style:scale-95 data-starting-style:scale-95 data-ending-style:opacity-0 data-starting-style:opacity-0", className);
    $[8] = className;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== showCloseButton) {
    t4 = showCloseButton && <DialogPrimitive.Close data-slot="dialog-close" render={<Button className="absolute top-4 right-4" size="icon-sm" variant="ghost" />}><X /><span className="sr-only">Close</span></DialogPrimitive.Close>;
    $[10] = showCloseButton;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== children || $[13] !== props || $[14] !== t3 || $[15] !== t4) {
    t5 = <DialogPrimitive.Popup className={t3} data-slot="dialog-content" {...props}>{children}{t4}</DialogPrimitive.Popup>;
    $[12] = children;
    $[13] = props;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t2 || $[18] !== t5) {
    t6 = <DialogPortal>{t2}{t5}</DialogPortal>;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function DialogHeader(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("mb-5 flex flex-col gap-1", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} data-slot="dialog-header" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DialogFooter(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("mt-6 flex justify-end gap-2", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} data-slot="dialog-footer" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DialogTitle(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("font-semibold text-foreground text-lg", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <DialogPrimitive.Title className={t1} data-slot="dialog-title" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DialogDescription(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-muted-foreground text-sm", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <DialogPrimitive.Description className={t1} data-slot="dialog-description" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger };